<script setup lang="ts">
/**
 * RinganJudulBagian — padanan <CaSectionHeading>.
 *
 * CaSectionHeading sendiri sudah murni CSS; yang membuatnya menyeret Nuxt UI
 * hanyalah <CaBadge> di dalamnya. Komponen ini identik baris-per-baris, cuma
 * menukar badge itu dengan <RinganLencana>.
 */
withDefaults(
  defineProps<{
    badge?: string
    badgeIkon?: string
    badgeTone?: 'netral' | 'emas' | 'emas-lembut' | 'ok'
    judul: string
    ringkas?: string
    /** Judul utama bagian dirender <h2>; sub-bagian pakai <h3>. */
    level?: 2 | 3
    tengah?: boolean
  }>(),
  { level: 2, badgeTone: 'netral' }
)
</script>

<template>
  <div :class="tengah ? 'max-w-2xl mx-auto text-center' : 'max-w-2xl'">
    <RinganLencana v-if="badge" :tone="badgeTone" :icon="badgeIkon">{{ badge }}</RinganLencana>

    <component
      :is="level === 2 ? 'h2' : 'h3'"
      class="text-ink text-balance"
      :class="[level === 2 ? 'ca-h2' : 'ca-h3', badge ? 'mt-4' : '']"
    >{{ judul }}</component>

    <p v-if="ringkas" class="mt-3 text-muted leading-relaxed">{{ ringkas }}</p>
  </div>
</template>
